import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TitleService {

    // BehaviorSubject pour observer les changements du token
    private titleSubject = new BehaviorSubject<boolean | null>(null);
    
    // Observable public pour que les composants puissent s'abonner
    public title$ = this.titleSubject.asObservable();


  constructor() {}

  /**
   * Récupère le embed depuis le sessionStorage
   * @returns string | null
   */
    public getHasTitle(): boolean {
        const hasTitle = sessionStorage.getItem('hasTitle');
        return hasTitle === 'true';
    }

  

        /**
   * Sauvegarde le embed dans le sessionStorage
   * @param hasTitle string
   */
  public setHasTitle(hasTitle: boolean): void {
    sessionStorage.setItem('hasTitle', String(hasTitle));
    // Émettre le nouveau Embed décodé
    this.titleSubject.next(hasTitle);
  }


    /**
   * Récupère le hasTitle depuis les paramètres de l'URL
   * @returns boolean
   */
    public getHasTitleFromUrl(): boolean {
      const urlParams = new URLSearchParams(window.location.search);
      const hasTitle = urlParams.get('hasTitle');
      return hasTitle === 'true';
    }
    
}